import React from "react";

function SakalaServicesKn() {
  return (
    <div className="body_style">
      <div className="letters-color-section">
        <h3 className="letters-color-section-main-heading">
          ಸಕಾಲದ ಅಡಿಯಲ್ಲಿ KSRTC ಸೇವೆಗಳು:
        </h3>
        <div className="letters-color-section-sub-heading-section">
          <h5 className="letters-color-section-sub-heading">
            ಸೇವಾ ನಿರ್ವಹಣೆಗಾಗಿ ಗೊತ್ತುಪಡಿಸಿದ ಕಛೇರಿಗಳಿಗಾಗಿ ಬಳಕೆದಾರರ ಕೈಪಿಡಿ:
          </h5>
          <span>ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ</span>
        </div>
        <div className="letters-color-section-sub-heading-section">
          <h5 className="letters-color-section-sub-heading">
            ಸಕಾಲ ಸೇವೆಗಳ ವಿವರಗಳನ್ನು ನೋಡಲು ನಾಗರಿಕರಿಗೆ:
          </h5>
          <span>ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ</span>
        </div>
      </div>
    </div>
  );
}

export default SakalaServicesKn;
